/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import { yupResolver } from '@hookform/resolvers/yup';
import { Modal, Box, Typography, Grid, Button } from '@mui/material';
import CustomInput from 'components/CustomInput/customInput';
import CustomSelect from 'components/CustomSelect/customSelect';
import { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { getAllListData, updateData } from 'services/CommonServices';
import { SETTING_ENDPOINT, ClientsENDPOINT } from 'utils/Constant';
import { ChangeClientSchema } from 'utils/ValidatorSchema';
import Closepng from 'assets/png/close.svg';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AccessDenied } from 'utils/helper';
import { useAppSelector } from 'store/hooks';

const clientChange: React.FC<{
  clientId?: any;
  currentClient: any;
  setLD: (val: any) => void;
  openClientchange: any;
  getInitialStatus:any
  setOpenClientchange: (val: any) => void;
}> = ({ clientId, currentClient, setLD, setOpenClientchange,getInitialStatus, openClientchange }) => {
  const [ClientData, setClientData] = useState<any>([]);
  const navigate = useNavigate();
   const {
      userInfo: { organizationId: orgdy },
    }: any = useAppSelector((store: any) => store.userLogin);
  const handleClose = () => {
    setOpenClientchange(false);
  };
  const {
    handleSubmit,
    control,
    formState:  {errors },
  } = useForm<any>({
    defaultValues: {
      newClient: '',
      remarks: '',
    },
    reValidateMode: 'onChange',
    resolver: yupResolver(ChangeClientSchema),
  });
  
  const onSubmit = (data: any) => {
    setLD(true);
    const obj: any = {
      userId: data.newClient,
      remarks: data.remarks,
    };
    updateData(clientId, obj, ClientsENDPOINT.CLientOwnerChange, true)
      .then((res: any) => {
        setLD(false);
        handleClose();
        getInitialStatus()
      })
      .catch((e) => {
        setLD(false);
        if (e === 'Forbidden resource') {
          toast.error(AccessDenied);
          navigate('/dashboard');
        }
        console.log(e);
      });
  };
  useEffect(() => {
    if (clientId) {      
      getAllListData(
        `${SETTING_ENDPOINT.users}/lite?moduleId=1&screenId=1&sortby=name&order=asc&organizationId=${orgdy}`,
        true,
      )
        .then((res: any) => {
          const options: any = [];
          res &&
            res?.data &&
            res?.data
              ?.filter((es: any) => es?.id !== currentClient[0]?.clientOwnerChange?.newUserId)
              ?.map((e: any) => {
                options.push({
                  label: ` ${e?.firstName} ${e?.lastName ? e?.lastName : ''}`,
                  value: e?.id,
                });
              });
          setClientData(options);
        })
        .catch((e: any) => {
          console.log(e);
        });
    }
  }, [clientId]);
  return (
    <Modal open={openClientchange} onClose={handleClose}>
      <Box className='logout-modal' sx={{ paddingBottom: '40px' }}>
        <Typography className='text-right'>
          <img src={Closepng} alt='close' onClick={handleClose} />
        </Typography>
        <Typography className='l-title'>Owner Change</Typography>
        <form
          id='currentClient'
          className='private-form'
          style={{ padding: '0px 50px 0px 50px' }}
          onSubmit={handleSubmit(onSubmit)}>
          <Grid container columnSpacing={2} sx={{ marginTop: '30px' }}>
            <Grid item md={12} sm={12} xs={12}>
              <Typography component={'div'} className='custom-field'>
                <Typography component={'p'} sx={{ textTransform: 'capitalize' }}>
                  {currentClient[0]?.createdBy?.firstName}{' '}
                  {currentClient[0]?.createdBy?.lastName ? currentClient[0]?.createdBy?.lastName : ''}: (Existing Owner)
                </Typography>
              </Typography>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Typography component={'div'} className='custom-field'>
                <Typography component={'p'}>New Owner</Typography>
                <Controller
                  control={control}
                  defaultValue={''}
                  name='newClient'
                  render={({ field: { onChange, value, name } }) => {
                    return (
                      <CustomSelect
                        labelKey={'label'}
                        valueKey={'value'}
                        options={ClientData}
                        name={name}
                        value={value}
                        onChange={(e) => {
                          onChange(e);
                        }}
                        placeHolder='Select'
                        error={errors.newClient?.message}
                      />
                    );
                  }}
                />
              </Typography>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Typography component={'div'} className='custom-field'>
                <Typography component={'p'}>Remarks</Typography>
                <Controller
                  name='remarks'
                  control={control}
                  render={({ field: { onChange, value, name } }) => (
                    <CustomInput
                      value={value ? value : ''}
                      name={name}
                      isTextArea={true}
                      className='custom-input'
                      placeHolder='Remarks'
                      error={errors.remarks?.message}
                      onChange={(e) => {
                        onChange(e);
                      }}
                    />
                  )}
                />
              </Typography>
            </Grid>
          </Grid>
        </form>
        <Typography className='d-flex-ja mt-10'>
          <Button className='l-cancel-btn mr-16' onClick={handleClose}>
            Cancel
          </Button>
          <Button className='l-save-btn' form={'currentClient'} type={'submit'}>
            Save
          </Button>
        </Typography>
      </Box>
    </Modal>
  );
};
export default clientChange;
